<!-- Header -->
<div class="frontpage-widget cover-image-trees-gray">
    <div class="whitebox dark-blue">
        <div class="container">
            <p class="text-muted">
                SCREENING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2 i18n>{{location.name}}</h2>
            <p i18n>
                <span class="text-muted">Lokalitetsnummer: </span>{{location.number}}
            </p>
            <p *ngIf="location.isLandfill" i18n>Losseplads</p>
        </div>
    </div>
</div>

<!-- location data -->
<div class="container">
    <div *ngIf="loading" class="mt-5 text-center">
        <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
        <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter lokalitet... </h3>
        <p class="text-muted mt-1">Det tager et øjeblik</p>
    </div>

    <div *ngIf="!loading && !screeningLocationDetails.hasV2Polygon && !screeningLocationDetails.hasV1Polygon"
        class="col-sm-12 col-lg-12 mb-5 mt-5 text-center">
        <img style="width:6rem" src="assets/undraw_no_data_qbuo.svg">
        <h6 class="text-muted mt-3" i18n>Denne lokalitet indeholder ingen data :(</h6>
    </div>
    <div [hidden]="loading" *ngIf="screeningLocationDetails.hasV2Polygon || screeningLocationDetails.hasV1Polygon">
        <div class="row mt-5">
            <div class="col-sm-12 col-lg-3">
                <div *ngIf="loading" class="vd-card screening-result p-4 text-center">
                    <h5 class=" text-muted"><i class="fa fa-spinner fa-spin"></i> Indlæser...</h5>
                </div>
                <div *ngIf="!loading && showV2LocationDetails" class="vd-card screening-result p-4 mb-4">
                    <!-- V2 polygon data -->
                    <div>
                        <div class="form-group">
                            <div class="result-value">
                                <h5 i18n>{{ getLeftBoxTitle() }}</h5>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Screeningsresultat:</label>
                            <div class="result-value">
                                <div class="risk-indicator-screening"
                                    [ngClass]="{
                                    'no-risk': (!screeningLocationDetails.v2PolygonResult.hasData || screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk),
                                    'risk': screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.Risk,
                                    'olie-benzin': screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter}">
                                </div>
                                <span i18n>
                                    Maksimal overskridelse:
                                    <b
                                        [ngClass]="{'text-danger':(screeningLocationDetails.v2PolygonResult.hasData && screeningLocationDetails.v2PolygonResult.factor > 1)}">
                                        <span
                                            *ngIf="screeningLocationDetails.v2PolygonResult.hasData && !isNaN(screeningLocationDetails.v2PolygonResult.factor)">
                                            {{screeningLocationDetails.v2PolygonResult.factor | number:'1.0-1'}}
                                        </span>
                                        <span
                                            *ngIf="!screeningLocationDetails.v2PolygonResult.hasData || isNaN(screeningLocationDetails.v2PolygonResult.factor)">-</span>
                                    </b>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Risikovurdering:</label>

                            <ng-container *ngIf="!screeningLocationDetails.v2PolygonResult.hasData">
                                <div><span class="text-muted">Utilstrækkeligt vurderingsgrundlag</span></div>
                            </ng-container>

                            <ng-container *ngIf="screeningLocationDetails.v2PolygonResult.hasData">
                                <div class="result-value">
                                    <span class="text-muted"
                                        *ngIf="screeningLocationDetails.v2PolygonResult.reassessment" i18n>
                                        Lokaliteten er revurderet til:
                                    </span>

                                    <span
                                        *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk">
                                        <b>Ingen risiko</b>
                                    </span>
                                    <span
                                        *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                                        <b i18n>Risiko</b>
                                    </span>
                                    <span
                                        *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter">
                                        <b i18n>Olie- og benzinprodukter</b>
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Modelstoffer:</label>
                            <div>
                                <a href="javascript:void(0)" (click)="showMissingModelCompounds()">
                                    Liste over manglende modelstoffer
                                </a>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Eksporter:</label>
                            <div>
                                <a href="javascript:void(0)" (click)="exportPDF()">
                                    Eksporter til PDF
                                </a>
                            </div>
                            <div>
                                <a href="javascript:void(0)" (click)="downloadCsv()">
                                    Eksporter til CSV
                                </a>
                            </div>
                        </div>

                        <div class="form-group" *ngIf="screeningLocationDetails.v2PolygonResult.reassessment != null">
                            <label for="polutant">Revurderet af:</label>
                            <div class="text-muted">
                                <i class="fa fa-user"></i>
                                {{screeningLocationDetails.v2PolygonResult.reassessment.caseWorker.name}}
                                <span class="ml-2  ">
                                    <i class="fa fa-comment"></i>
                                    <span class="bg-light">
                                        <b>"</b>
                                        <span>{{reassessmentEllipsisComment(screeningLocationDetails.v2PolygonResult)}}</span>
                                        <b>"</b>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group"
                            *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                            <a [routerLink]="['/riskassessment/location-details', location.id]">
                                Se lokalitet i Risikovurdering
                            </a>
                        </div>

                        <div class="form-group mb-0">
                            <ng-container
                                *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus !== screeningPolygonStatus.OlieOgBenzinprodukter">
                                <a class="btn btn-primary" href="#"
                                    *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus === screeningPolygonStatus.NoRisk"
                                    (click)="onOpenModal(polygonType.V2, screeningPolygonStatus.NoRisk)"
                                    data-toggle="modal" data-target="#reassessModal">Revurder til 'Risiko'</a>
                                <a class="btn btn-primary" href="#"
                                    *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus === screeningPolygonStatus.Risk"
                                    (click)="onOpenModal(polygonType.V2, screeningPolygonStatus.Risk)"
                                    data-toggle="modal" data-target="#reassessModal">Revurder til 'Ingen risiko'</a>
                            </ng-container>
                            <ng-container
                                *ngIf="screeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter">
                                <a class="btn btn-primary" href="#"
                                    (click)="onOpenModal(polygonType.V2, screeningPolygonStatus.NoRisk)"
                                    data-toggle="modal" data-target="#reassessModal">Vurder til 'Risiko'</a>
                                <a class="btn btn-primary" href="#"
                                    (click)="onOpenModal(polygonType.V2, screeningPolygonStatus.Risk)"
                                    data-toggle="modal" data-target="#reassessModal">Vurder til 'Ingen risiko'</a>
                            </ng-container>
                        </div>

                    </div>
                </div>

                <div *ngIf="!loading && showV1LocationDetails" class="vd-card screening-result p-4 mb-4">
                    <!-- V1 polygon data -->
                    <div>
                        <div class="form-group">
                            <div class="result-value">
                                <h5 i18n>{{ getLeftBoxTitle() }}</h5>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Screeningsresultat:</label>
                            <div class="result-value">
                                <div class="risk-indicator-screening"
                                    [ngClass]="{
                                    'no-risk': (!screeningLocationDetails.v1PolygonResult.hasData || screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk),
                                    'risk': screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.Risk,
                                    'olie-benzin': screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter}">
                                </div>

                                <span i18n>
                                    Maksimal overskridelse:
                                    <b
                                        [ngClass]="{'text-danger':(screeningLocationDetails.v1PolygonResult.hasData && screeningLocationDetails.v1PolygonResult.factor > 1)}">
                                        <span
                                            *ngIf="screeningLocationDetails.v1PolygonResult.hasData && !isNaN(screeningLocationDetails.v1PolygonResult.factor)">
                                            {{screeningLocationDetails.v1PolygonResult.factor | number:'1.0-2'}}
                                        </span> <span
                                            *ngIf="!screeningLocationDetails.v1PolygonResult.hasData || isNaN(screeningLocationDetails.v1PolygonResult.factor)">-</span>
                                    </b>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Risikovurdering:</label>
                            <ng-container *ngIf="!screeningLocationDetails.v1PolygonResult.hasData">
                                <div><span class="text-muted">Utilstrækkeligt vurderingsgrundlag</span></div>
                            </ng-container>

                            <ng-container *ngIf="screeningLocationDetails.v1PolygonResult.hasData">
                                <div class="result-value">
                                    <span class="text-muted"
                                        *ngIf="screeningLocationDetails.v1PolygonResult.reassessment != null" i18n>
                                        Lokaliteten er revurderet til:
                                    </span>

                                    <span
                                        *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk">
                                        <b>Ingen risiko</b>
                                    </span>
                                    <span
                                        *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                                        <b i18n>Risiko</b>
                                    </span>
                                    <span
                                        *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter">
                                        <b i18n>Olie- og benzinprodukter</b>
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Modelstoffer:</label>
                            <div>
                                <a href="javascript:void(0)" (click)="showMissingModelCompounds()">
                                    Liste over manglende modelstoffer
                                </a>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Eksporter:</label>
                            <div>
                                <a href="javascript:void(0)" (click)="exportPDF()">
                                    Eksporter til PDF
                                </a>
                            </div>
                            <div>
                                <a href="javascript:void(0)" (click)="downloadCsv()">
                                    Eksporter til CSV
                                </a>
                            </div>
                        </div>

                        <div class="form-group" *ngIf="screeningLocationDetails.v1PolygonResult.reassessment != null">
                            <label for="polutant">Revurderet af:</label>
                            <div class="text-muted">
                                <i class="fa fa-user"></i>
                                {{screeningLocationDetails.v1PolygonResult.reassessment.caseWorker.name}}
                                <span class="ml-2  ">
                                    <i class="fa fa-comment"></i> <span
                                        class="bg-light"><b>"</b><span>{{reassessmentEllipsisComment(screeningLocationDetails.v1PolygonResult)}}</span><b>"</b></span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group"
                            *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                            <a href="javascript:void(0)" (click)="newV1Calculation()">
                                <span>Foretag risikovurdering som V2</span>
                            </a>
                        </div>

                        <div class="form-group mb-0">
                            <ng-container
                                *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus !== screeningPolygonStatus.OlieOgBenzinprodukter">
                                <a class="btn btn-primary"
                                    *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus === screeningPolygonStatus.NoRisk"
                                    href="#" (click)="onOpenModal(polygonType.V1, screeningPolygonStatus.NoRisk)"
                                    data-toggle="modal" data-target="#reassessModal">Revurder til 'Risiko'</a>
                                <a class="btn btn-primary"
                                    *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus === screeningPolygonStatus.Risk"
                                    href="#" (click)="onOpenModal(polygonType.V1, screeningPolygonStatus.Risk)"
                                    data-toggle="modal" data-target="#reassessModal">Revurder til 'Ingen risiko'</a>
                            </ng-container>

                            <ng-container
                                *ngIf="screeningLocationDetails.v1PolygonResult.polygonStatus === screeningPolygonStatus.OlieOgBenzinprodukter">
                                <a class="btn btn-primary" href="#"
                                    (click)="onOpenModal(polygonType.V1, screeningPolygonStatus.NoRisk)"
                                    data-toggle="modal" data-target="#reassessModal">Vurder til 'Risiko'</a>
                                <a class="btn btn-primary" href="#"
                                    (click)="onOpenModal(polygonType.V1, screeningPolygonStatus.Risk)"
                                    data-toggle="modal" data-target="#reassessModal">Vurder til 'Ingen risiko'</a>
                            </ng-container>
                        </div>

                    </div>
                </div>

                <div class="vd-card screening-result p-4 mb-3">
                    <div>
                        <h5 class="text-center"> Screeningslog </h5>
                        <hr class="mt-4 mb-2" />
                        <h6 class="text-center">{{screeningLocationDetails.screeningLog.newScreeningAt | date:'d/M/yyyy HH:mm'}}</h6>
                    </div>
                    <div>
                        <div class="mt-3">
                            <b>Der er screenet på baggrund af:</b>
                            <p
                                *ngIf="screeningLocationDetails.screeningLog.screeningTriggeredBy === screeningTriggeredBy.GrundriskRescreening">
                                Genberegning i Grundrisk
                            </p>
                            <p *ngIf="screeningLocationDetails.screeningLog.screeningTriggeredBy === screeningTriggeredBy.Dkjord">
                                Ændring i DKjord
                            </p>
                        </div>
                        <div class="mt-3">
                        </div>
                        <div class="mt-3">
                            <b>Screening er gemt pga:</b>
                            <div [ngSwitch]="screeningLocationDetails.screeningLog.reasonToSave">
                                <p *ngSwitchCase="reasonToSaveScreening.FirstTimeSaved">
                                    <span i18n>1. gang der er screenet lokalitet</span>
                                </p>
                                <div *ngSwitchCase="reasonToSaveScreening.AppliedOverrulingScreening">
                                    <p *ngFor="let appliedRule of screeningLocationDetails.screeningLog.overrulingScreeningRulesApplied">
                                        <span i18n *ngIf="appliedRule === overrulingScreeningType.ExceedingFactorChangedToLargerOrEqualOneRule">
                                            Nye screening har større overskridelsesfaktor
                                            {{screeningLocationDetails.screeningLog.addedExceedFactor | number:'1.0-2'}} end den forrige, hvor den var på
                                            {{screeningLocationDetails.screeningLog.removedExceedFactor | number:'1.0-2'}}.
                                        </span>
                                        <span i18n *ngIf="appliedRule === overrulingScreeningType.ExceedingFactorChangedToSmallerThanOneRule">
                                            Nye screening har mindre overskridelsesfaktor
                                            {{screeningLocationDetails.screeningLog.addedExceedFactor | number:'1.0-2'}} end den forrige, hvor den var på
                                            {{screeningLocationDetails.screeningLog.removedExceedFactor | number:'1.0-2'}}.
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.ExceedingFactorExceedLimitationRule">
                                            Der er sket en ændring i overskridelsesfaktor på mere end {{exceedingFactorLimitation}}%.
                                            <br />
                                            Faktoren er nu: {{screeningLocationDetails.screeningLog.addedExceedFactor | number:'1.0-2'}}
                                            <br />
                                            Faktoren var før: {{screeningLocationDetails.screeningLog.removedExceedFactor | number:'1.0-2'}}
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.FlagsChangedRule">
                                            Der er sket en ændring i lokalitetens screeningsflag.
                                            <br />
                                            Nu er der følgende flag:
                                            <ul class="mb-0">
                                                <li
                                                    *ngFor="let flag of convertScreeningFlagsToDanish(screeningLocationDetails.screeningLog.addedFlags)">
                                                    {{flag}}
                                                </li>
                                            </ul>
                                            og før var der:
                                            <ul class="mb-0">
                                                <li
                                                    *ngFor="let flag of convertScreeningFlagsToDanish(screeningLocationDetails.screeningLog.removedFlags)">
                                                    {{flag}}
                                                </li>
                                            </ul>
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.PollutantsChangedRule">
                                            Der er sket en ændring i screenede stoffer.
                                            <br />
                                            <span *ngIf="screeningLocationDetails.screeningLog.addedPollutants.length > 0">
                                            Følgende stoffer er tilføjet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let pollutant of screeningLocationDetails.screeningLog.addedPollutants">
                                                        {{pollutant}}
                                                    </li>
                                                </ul>
                                            </span>
                                            <span *ngIf="screeningLocationDetails.screeningLog.removedPollutants.length > 0">
                                            og følgende stoffer er fjernet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let pollutant of screeningLocationDetails.screeningLog.removedPollutants">
                                                        {{pollutant}}
                                                    </li>
                                                </ul>
                                            </span>
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.PollutionCausesChangedRule">
                                            Der er sket en ændring i screenede brancher.
                                            <br />
                                            <span *ngIf="screeningLocationDetails.screeningLog.addedPollutionCauses.length > 0">
                                            Følgende brancher er tilføjet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let pollutantCauseName of
                                                    getPollutionCauseNamesOfLog(screeningLocationDetails.screeningLog.addedPollutionCauses)">
                                                        {{pollutantCauseName}}
                                                    </li>
                                                </ul>
                                            </span>
                                            <span *ngIf="screeningLocationDetails.screeningLog.removedPollutionCauses.length > 0">
                                            og følgende brancher er fjernet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let pollutantCauseName of
                                                    getPollutionCauseNamesOfLog(screeningLocationDetails.screeningLog.removedPollutionCauses)">
                                                        {{pollutantCauseName}}
                                                    </li>
                                                </ul>
                                            </span>
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.ActivitiesChangedRule">
                                            Der er sket en ændring i screenede aktiviteter.
                                            <br />
                                            <span *ngIf="screeningLocationDetails.screeningLog.addedActivities.length > 0">
                                            Følgende aktiviteter er tilføjet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let activityName of
                                                    getActivityNamesOfLog(screeningLocationDetails.screeningLog.addedActivities)">
                                                        {{activityName}}
                                                    </li>
                                                </ul>
                                            </span>
                                            <span *ngIf="screeningLocationDetails.screeningLog.removedActivities.length > 0">
                                            og følgende aktiviteter er fjernet:
                                                <ul class="mb-0">
                                                    <li *ngFor="let activityName of
                                                    getActivityNamesOfLog(screeningLocationDetails.screeningLog.removedActivities)">
                                                        {{activityName}}
                                                    </li>
                                                </ul>
                                            </span>
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.SumV1PolygonAreaExceedLimitationRule">
                                            Der er sket en ændring i summen af V1 forureningsfladers areal, som er har ændret sig med mere end {{sumV1PolygonAreaExceedLimitation}}%.
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.SumV2PolygonAreaExceedLimitationRule">
                                            Der er sket en ændring i summen af V2 forureningsfladers areal, som er har ændret sig med mere end {{sumV2PolygonAreaExceedLimitation}}%.
                                        </span>
                                        <span i18n *ngIf="appliedRule ===  overrulingScreeningType.MissingModelCompoundsChangedRule">
                                            Der er sket en ændring i aktiviteter/brancher som ikke kan oversættes til stoffer eller stoffer, som
                                            ikke kan oversættes til modelstoffer siden den forrige screening.
                                        </span>
                                    </p>
                                </div>
                                <div *ngSwitchDefault></div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <b>Dato for forrige screening:</b>
                            <div [ngSwitch]="screeningLocationDetails.screeningLog.reasonToSave">
                                <p *ngSwitchCase="reasonToSaveScreening.FirstTimeSaved">
                                    Ingen tidligere.
                                </p>
                                <p *ngSwitchCase="reasonToSaveScreening.AppliedOverrulingScreening">
                                    {{screeningLocationDetails.screeningLog.previousScreeningAt | date:'d/M/yyyy HH:mm'}}
                                </p>
                                <p *ngSwitchDefault></p>
                            </div>
                        </div>
                        <div class="mt-3">
                            <b>Var forrige screening manuelt revurderet:</b>
                            <p *ngIf="screeningLocationDetails.screeningLog.reassessedToStatus !== null">
                                Ja
                            </p>
                            <p *ngIf="screeningLocationDetails.screeningLog.reassessedToStatus === null">
                                Nej
                            </p>
                        </div>
                        <div class="mt-3" *ngIf="screeningLocationDetails.screeningLog.reassessedToStatus !== null">
                            <b>Kommentar til revurderingen: </b>
                            <p>
                                {{screeningLocationDetails.screeningLog.reassessmentComment}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-9">
                <div class="ml-3 mb-5">
                    <h5 for="polutant" class="ml-0">Flag:</h5>
                    <div class="row ml-0">
                        <div *ngIf="!hasAnyFlags()">
                            <span class="text-muted">
                                <i class="fa fa-thumbs-up fa-lg"></i>
                                Ingen flag på denne lokalitet
                            </span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Bly_kobber_eller_PAH)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Bly, kobber eller PAH fjernet i trin 1</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Kompleks_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Område med kompleks geologi</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Manglende_modelstof)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Et eller flere forureningsstoffer mangler et modelstof</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Svag_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Svag datadækning for bestemmelse af dæklagstykkelser</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.MTBE_fjernet)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>MTBE fjernet</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Boring_uden_ler)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Lokalitet har boring uden ler i en radius af 100-300 m fra kant</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Risiko_pga_vandindvinding)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet udgør en risiko fordi der ligger en vandindvindingsboring indenfor 100 m
                            </span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Kun_Olie_Benzin_Stoffer)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet er udelukkende forurenet med olie- og benzin stoffer
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-lg-12 mb-4">
                    <a href="javascript:void(0)" class=" float-right  btn btn-primary btn-sm"
                        (click)="showScreeningResultHistoryModal()">
                        <i class="fa fa-history fa-lg"></i>
                        <span class="text-uppercase"> Se Screeningshistorik</span>
                    </a>
                    <!-- Tables of screenings -->
                    <!-- V2 -->
                    <div *ngIf="screeningLocationDetails.hasV2Polygon">
                        <ng-container [ngTemplateOutlet]="tmplPolygonType"
                            [ngTemplateOutletContext]="{pType: polygonType.V2, screeningResults: v2ScreeningResults}">
                        </ng-container>
                    </div>
                    <!-- V1 -->
                    <div *ngIf="screeningLocationDetails.hasV1Polygon">
                        <ng-container [ngTemplateOutlet]="tmplPolygonType"
                            [ngTemplateOutletContext]="{pType: polygonType.V1, screeningResults: v1ScreeningResults}">
                        </ng-container>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>

<ng-template #tmplPolygonType let-pType="pType" let-screeningResults="screeningResults">
    <ng-container *ngFor="let resultKey of getObjectKeys(screeningResults); let index = index;">
        <div>
            <h4 class="d-inline-block">
                {{polygonType[pType]}} - {{ resultKey | number:'1.2-2' }} m<sup>2</sup> - Screeningsresultater</h4>
            <hr />
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.Pollutant, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.Pollutant)}">
            </ng-container>
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.PollutionCause, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.PollutionCause)}">
            </ng-container>
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.Activity, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.Activity)}">
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<!-- ScreeningResults template -->
<ng-template #tmpScreeningResults let-cTranslationType="cTranslationType" let-screeningResults="screeningResults">
    <ng-container *ngIf="screeningResults.length > 0">
        <ng-container [ngSwitch]="cTranslationType">
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Pollutant">Stoffer</h5>
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.PollutionCause">Brancher</h5>
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Activity">Aktiviteter</h5>
        </ng-container>

        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Dato</th>
                    <ng-container [ngSwitch]="cTranslationType">
                        <ng-container *ngSwitchCase="compoundTranslationType.Pollutant">
                            <th>Stofnavn</th>
                            <th>Kildestørrelse</th>
                        </ng-container>
                        <ng-container class="font-italic mb-0 mt-1"
                            *ngSwitchCase="compoundTranslationType.PollutionCause">
                            <th>Branche</th>
                            <th>Kildestørrelse</th>
                            <th>Stofnavn</th>
                        </ng-container>
                        <ng-container class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Activity">
                            <th>Aktiviteter </th>
                            <th>Kildestørrelse</th>
                            <th>Stofnavn</th>
                        </ng-container>
                    </ng-container>
                    <th>Stofkilde</th>
                    <th>Kvalitetskriterie</th>
                    <th> <small class="text-muted">Worst case</small><br> Koncentration </th>
                    <th> <small class="text-muted">100m nedstrøms</small><br> Koncentration </th>
                    <th>Årsag til frasortering</th>
                    <th>Faktor</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let result of screeningResults">
                    <tr [routerLink]="['/screening/compound-details', result.id]">
                        <td>{{result.createdAt | date:'d/M-yyyy HH:mm'}}</td>
                        <ng-container [ngSwitch]="cTranslationType">
                            <ng-container *ngSwitchCase="compoundTranslationType.Pollutant">
                                <td>{{result.compoundName}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                            </ng-container>
                            <ng-container class="font-italic mb-0 mt-1"
                                *ngSwitchCase="compoundTranslationType.PollutionCause">
                                <td>{{result.industry?.name}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                                <td>{{result.compoundName}}</td>
                            </ng-container>
                            <ng-container class="font-italic mb-0 mt-1"
                                *ngSwitchCase="compoundTranslationType.Activity">
                                <td>{{result.activity?.name}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                                <td>{{result.compoundName}}</td>
                            </ng-container>
                        </ng-container>

                        <td>{{getCompoundOriginText(result.compoundOrigin)}}</td>
                        <td>{{getQualityCriterium(result?.qualityCriterion)}}
                            <span *ngIf="result?.qualityCriterion > 0">μg/L</span>
                        </td>
                        <td>{{getNumberWithSignificantDigits(result.worstCaseConcentration)}} μg/L</td>
                        <td>{{getNumberWithSignificantDigits(result.concentrationDownstream)}} μg/L</td>
                        <td>
                            <i *ngIf="result.removalReason === ''" class="fa fa-minus"></i>
                            {{getRemovalReason(result.removalReason)}}
                        </td>
                        <td>
                            <b [ngClass]="{'text-danger': result.factor > 1}">
                                {{ getFactor(result.factor, result.qualityCriterion, result.concentrationDownstream) }}
                            </b>
                        </td>
                        <td>
                            <span *ngIf="result.flag > 0 && hasFlag(result.flag)">
                                <i class="fa fa-flag text-danger"></i>
                            </span>
                            <span *ngIf="result.flag === 0 || !hasFlag(result.flag)"> - </span>
                        </td>
                    </tr>
                </ng-container>

            </tbody>
        </table>
    </ng-container>
</ng-template>


<button #showScreeningResultHistoryButton style="display:none;" data-toggle="modal"
    data-target="#screeningResultHistory">
</button>
<button #showMissingModelCompoundButton style="display:none;" data-toggle="modal" data-target="#missingModelCompound">
</button>

<div class="modal fade" id="reassessModal" tabindex="-1" role="dialog" aria-labelledby="reassessModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body pt-5 px-5 pb-3">
                <h5 i18n>Revurder lokation</h5>
                <p *ngIf="reassessToStatus == screeningPolygonStatus.NoRisk">
                    Denne lokation er vurderet til
                    <u>ikke</u> at udgøre en risiko og er ikke tilgængelig i den endelige risikovurdering. Ved at
                    revurdere
                    lokationen gøres den tilgængelig for risikovurdering.
                </p>

                <p *ngIf="reassessToStatus == screeningPolygonStatus.Risk">
                    Denne lokation er vurderet til at udgøre en risiko og er dermed
                    <u>tilgængelig</u> i den endelige risikovurdering. Ved at revurdere lokationen vil den
                    <u>ikke længere</u> være tilgængelig for risikovurdering.
                </p>

                <div class="form-group pt-4">
                    <label for="exampleFormControlTextarea1">Giv en begrundelse for revurdering:</label>
                    <textarea [(ngModel)]="reassessRemark" class="form-control" id="exampleFormControlTextarea1"
                        placeholder="Skriv begrundelse..." rows="3"></textarea>
                </div>

                <div *ngIf="missingRemark">
                    <p class="text-danger">*Bemærkning er påkrævet</p>
                </div>
            </div>
            <div class="modal-footer pb-5 px-5 pt-4">
                <button id="reasessModalCloseButton" type="button" class="btn btn-secondary" data-dismiss="modal"
                    #reasessModalCloseButton>
                    Fortryd
                </button>

                <button type="button" class="btn btn-dark" style="width: 12rem" (click)="reassess()">

                    <span style="pointer-events: none"
                        *ngIf="!loading && reassessToStatus == screeningPolygonStatus.NoRisk">
                        <i class="fa fa-check"></i> Revurder (til 'risiko')
                    </span>
                    <span style="pointer-events: none"
                        *ngIf="!loading && reassessToStatus == screeningPolygonStatus.Risk">
                        <i class="fa fa-check"></i> Revurder (til 'ingen risiko')
                    </span>
                    <span *ngIf="loading">
                        <i class="fa fa-spinner fa-spin"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="preliminaryModal" tabindex="-1" role="dialog" aria-labelledby="preliminaryModal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-body pt-5 px-5 pb-3">
                <h5 i18n>Foreløbig risikovurdering </h5>
                <p i18n>
                    Denne lokalitet er kun V1 screenet. Det er muligt at foretage indledende beregninger, men disse kan
                    ikke ophøjes til gældende
                    risikovurderinger.
                </p>


                <div class="form-group pt-4">
                    <label for="exampleFormControlTextarea1">Giv en begrundelse for foreløbig undersøgelse:</label>
                    <textarea [(ngModel)]="reassessRemark" class="form-control" id="exampleFormControlTextarea1"
                        placeholder="Skriv begrundelse..." rows="3"></textarea>
                </div>
            </div>
            <div class="modal-footer pb-5 px-5 pt-4">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>

                <button type="button" class="btn btn-dark" data-dismiss="modal">
                    Fortsæt
                </button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="location" class="modal fade" id="screeningResultHistory" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content p-4">

            <div class="modal-body">
                <h2>Screeningshistorik</h2>
                <p class="text-muted">{{location?.number}} - {{location?.name}}</p>

                <div *ngIf="!isHistoryLoaded" class="mt-5 text-center">
                    <app-load-indicator style="width: 20px; height: 20px;"></app-load-indicator>
                    <h6 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter historik... </h6>
                    <p class="text-muted mt-1">Det tager et øjeblik</p>
                </div>

                <div *ngIf="isHistoryLoaded">
                    <div *ngIf="screeningHistories == null || screeningHistories.length === 0">
                        <hr class="mt-4 mb-2" />
                        <h6 class="vd-text-muted">Ingen screeninger...</h6>
                    </div>

                    <div>
                        <div *ngFor="let screeningHistory of screeningHistories | orderBy:'-createdAt'; let j = index"
                            class=" mb-4">
                            <h6 data-toggle="collapse" [ngClass]="{'collapsed': j != 0}" style="cursor: pointer"
                                [attr.data-target]="'#item' + j" [attr.aria-controls]="'item' + j"
                                [attr.aria-expanded]="j == 0">
                                <i class="fa "></i> Screening {{screeningHistory.createdAt | date:'d/M - y'}}
                            </h6>
                            <div class="collapse collapse-content" [ngClass]="{'show': j == 0}" [id]="'item'+ j">
                                <div>
                                    <h6 class="collapsed" data-toggle="collapse" style="cursor: pointer"
                                        [attr.data-target]="'#logs' + j" [attr.aria-controls]="'logs' + j">
                                        <i class="fa"></i>
                                        Log
                                    </h6>

                                    <div class="collapse collapse-content mb-2" [id]="'logs'+ j">
                                        <div class="vd-card screening-result p-3">
                                            <div *ngIf="screeningHistory !== null && screeningHistory.screeningLog !== null">
                                                <div>
                                                    <b>Der er screenet på baggrund af:</b>
                                                    <p *ngIf="screeningHistory.screeningLog.screeningTriggeredBy === screeningTriggeredBy.GrundriskRescreening">
                                                        Genberegning i Grundrisk
                                                    </p>
                                                    <p *ngIf="screeningHistory.screeningLog.screeningTriggeredBy === screeningTriggeredBy.Dkjord">
                                                        Ændring i DKjord
                                                    </p>
                                                </div>
                                                <div class="mt-3">
                                                </div>
                                                <div class="mt-3">
                                                    <b>Screening er gemt pga:</b>
                                                    <div [ngSwitch]="screeningHistory.screeningLog.reasonToSave">
                                                        <p *ngSwitchCase="reasonToSaveScreening.FirstTimeSaved">
                                                            <span i18n>1. gang der er screenet lokalitet</span>
                                                        </p>
                                                        <div *ngSwitchCase="reasonToSaveScreening.AppliedOverrulingScreening">
                                                            <p *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied.length > 0">
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.ExceedingFactorChangedToLargerOrEqualOneRule">
                                                                    Nye screening har større overskridelsesfaktor {{screeningHistory.screeningLog.addedExceedFactor | number:'1.0-2'}} end den
                                                                    forrige, hvor den var på {{screeningHistory.screeningLog.removedExceedFactor | number:'1.0-2'}}.
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.ExceedingFactorChangedToSmallerThanOneRule">
                                                                    Nye screening har mindre overskridelsesfaktor {{screeningHistory.screeningLog.addedExceedFactor | number:'1.0-2'}} end den
                                                                    forrige, hvor den var på {{screeningHistory.screeningLog.removedExceedFactor | number:'1.0-2'}}.
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.ExceedingFactorExceedLimitationRule">
                                                                    Nye screening har en ændring på over 5% da nye overskridelsesfaktor er
                                                                    {{screeningHistory.screeningLog.addedExceedFactor | number:'1.0-2'}} end den forrige, hvor den var på
                                                                    {{screeningHistory.screeningLog.removedExceedFactor | number:'1.0-2'}}.
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.FlagsChangedRule">
                                                                    Der er sket en ændring i lokalitetens screeningsflag.
                                                                    <br />
                                                                    Nu er der følgende flag:
                                                                    <ul class="mb-0">
                                                                        <li *ngFor="let flag of convertScreeningFlagsToDanish(screeningHistory.screeningLog.addedFlags)">
                                                                            {{flag}}
                                                                        </li>
                                                                    </ul>
                                                                    og før var der:
                                                                    <ul class="mb-0">
                                                                        <li *ngFor="let flag of convertScreeningFlagsToDanish(screeningHistory.screeningLog.removedFlags)">
                                                                            {{flag}}
                                                                        </li>
                                                                    </ul>
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.PollutantsChangedRule">
                                                                    Der er sket en ændring i screenede stoffer.
                                                                    <br />
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.addedPollutants.length > 0">
                                                                    Følgende stoffer er tilføjet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let pollutant of screeningHistory.screeningLog.addedPollutants">
                                                                                {{pollutant}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.removedPollutants.length > 0">
                                                                    og følgende stoffer er fjernet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let pollutant of screeningHistory.screeningLog.removedPollutants">
                                                                                {{pollutant}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.PollutionCausesChangedRule">
                                                                    Der er sket en ændring i screenede brancher.
                                                                    <br />
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.addedPollutionCauses.length > 0">
                                                                    Følgende brancher er tilføjet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let pollutantCauseName of
                                                                            getPollutionCauseNamesOfLog(screeningHistory.screeningLog.addedPollutionCauses)">
                                                                                {{pollutantCauseName}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.removedPollutionCauses.length > 0">
                                                                    og følgende brancher er fjernet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let pollutantCause of
                                                                            getPollutionCauseNamesOfLog(screeningHistory.screeningLog.removedPollutionCauses)">
                                                                                {{pollutantCauseName}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.ActivitiesChangedRule">
                                                                    Der er sket en ændring i screenede aktiviteter.
                                                                    <br />
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.addedActivities.length > 0">
                                                                    Følgende aktiviteter er tilføjet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let activityName of
                                                                            getActivityNamesOfLog(screeningHistory.screeningLog.addedActivities)">
                                                                                {{activityName}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                    <span *ngIf="screeningLocationDetails.screeningLog.removedActivities.length > 0">
                                                                    og følgende aktiviteter er fjernet:
                                                                        <ul class="mb-0">
                                                                            <li *ngFor="let activityName of
                                                                            getActivityNamesOfLog(screeningHistory.screeningLog.removedActivities)">
                                                                                {{activityName}}
                                                                            </li>
                                                                        </ul>
                                                                    </span>
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.SumV1PolygonAreaExceedLimitationRule">
                                                                    Der er sket en ændring i summen af V1 forureningsfladers areal, som er har ændret sig med mere end 5%.
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.SumV2PolygonAreaExceedLimitationRule">
                                                                    Der er sket en ændring i summen af V2 forureningsfladers areal, som er har ændret sig med mere end 5%.
                                                                </span>
                                                                <span i18n *ngIf="screeningHistory.screeningLog.overrulingScreeningRulesApplied[0] === overrulingScreeningType.MissingModelCompoundsChangedRule">
                                                                    Der er sket en ændring i aktiviteter/brancher som ikke kan oversættes til stoffer eller stoffer, som
                                                                    ikke kan oversættes til modelstoffer siden den forrige screening.
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <div *ngSwitchDefault></div>
                                                    </div>
                                                </div>
                                                <div class="mt-3">
                                                    <b>Dato for forrige screening:</b>
                                                    <div [ngSwitch]="screeningHistory.screeningLog.reasonToSave">
                                                        <p *ngSwitchCase="reasonToSaveScreening.FirstTimeSaved">
                                                            Ingen tidligere.
                                                        </p>
                                                        <p *ngSwitchCase="reasonToSaveScreening.AppliedOverrulingScreening">
                                                            {{screeningHistory.screeningLog.previousScreeningAt | date:'d/M/yyyy HH:mm'}}
                                                        </p>
                                                        <p *ngSwitchDefault></p>
                                                    </div>
                                                </div>
                                                <div class="mt-3">
                                                    <b>Var forrige screening manuelt revurderet:</b>
                                                    <p *ngIf="screeningHistory.screeningLog.reassessedToStatus !== null">
                                                        Ja
                                                    </p>
                                                    <p *ngIf="screeningHistory.screeningLog.reassessedToStatus === null">
                                                        Nej
                                                    </p>
                                                </div>
                                                <div class="mt-3" *ngIf="screeningHistory.screeningLog.reassessedToStatus !== null">
                                                    <b>Kommentar til revurderingen: </b>
                                                    <p>
                                                        {{screeningHistory.screeningLog.reassessmentComment}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    *ngIf="(filterScreeningResultHistoriesBy(screeningResultHistories, 'screeningId', screeningHistory.screeningId) | groupBy: ['polygonType', 'polygonArea']) as screeningResultHistoriesGroupByPolygon">
                                    <div
                                        *ngFor="let elementGroupByPolygon of screeningResultHistoriesGroupByPolygon | keyvalue | orderBy: '-key'; let k = index;">
                                        <h6 data-toggle="collapse" [ngClass]="{'collapsed': k != 0}" style="cursor: pointer"
                                            [attr.data-target]="'#itemTranslation_' + j +'_' + k" [attr.aria-controls]="'itemTranslation_' + j +'_' + k"
                                            [attr.aria-expanded]="k == 0">
                                            <i class="fa"></i>
                                            {{ getPolygonTypeString(elementGroupByPolygon.value[0].polygonType) }} -
                                            {{ getValidNumber(elementGroupByPolygon.value[0].polygonArea) |
                                            number:'1.0-2':'da'}}m<sup>2</sup>
                                        </h6>

                                        <div class="collapse collapse-content" [ngClass]="{'show': k == 0}" [id]="'itemTranslation_' + j +'_' + k"
                                            *ngIf="(elementGroupByPolygon.value | groupBy: ['compoundTranslationType']) as screeningResultHistoriesGroupByTranslation">
                                            <div
                                                *ngFor="let elementGroupByTranslation of screeningResultHistoriesGroupByTranslation | keyvalue | reverse; let m = index;">
                                                <h6 data-toggle="collapse" [ngClass]="{'collapsed': m != 0}" style="cursor: pointer"
                                                    [attr.data-target]="'#itemTranslation_' + j +'_' + k + '_' + 'itemGroupByTranslation' + m"
                                                    [attr.aria-controls]="'itemTranslation_' + j +'_' + k + '_' + 'itemGroupByTranslation' + m"
                                                    [attr.aria-expanded]="m == 0">
                                                    <i class="fa "></i>
                                                    {{ getTranslationTypeString(elementGroupByTranslation.value[0].compoundTranslationType) }}
                                                </h6>

                                                <div class="collapse collapse-content" [ngClass]="{'show': m == 0}"
                                                    [id]="'itemTranslation_' + j +'_' + k + '_' + 'itemGroupByTranslation'+ m">
                                                    <table class="table table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    *ngIf="elementGroupByTranslation.value[0].compoundTranslationType == compoundTranslationType.PollutionCause">
                                                                    Branche</th>
                                                                <th
                                                                    *ngIf="elementGroupByTranslation.value[0].compoundTranslationType == compoundTranslationType.Activity">
                                                                    Aktivitet</th>
                                                                <th>Forureningsstof</th>
                                                                <th>Kildestørrelser</th>
                                                                <th>Risikovurdering</th>
                                                                <th>Overskridelsesfaktor</th>
                                                                <th>Koncentration</th>
                                                                <th>Kvalitetskriterie</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let screeningResultHistory of elementGroupByTranslation.value">
                                                                <td *ngIf="elementGroupByTranslation.value[0].compoundTranslationType == compoundTranslationType.PollutionCause"
                                                                    style="word-break:break-all;">
                                                                    {{ screeningResultHistory.industry ?
                                                                    screeningResultHistory.industry.name : '' }}
                                                                </td>
                                                                <td *ngIf="elementGroupByTranslation.value[0].compoundTranslationType == compoundTranslationType.Activity"
                                                                    style="word-break:break-all;">
                                                                    {{ screeningResultHistory.activity ?
                                                                    screeningResultHistory.activity.name : '' }}
                                                                </td>
                                                                <td>{{screeningResultHistory.compoundName}}</td>
                                                                <td>{{screeningResultHistory.sourceSize | number }}</td>
                                                                <td>
                                                                    <span class="fa-stack risk-indicator"
                                                                        [ngClass]="{'risk-screening':(screeningResultHistory.excessFactor >= 1.0), 'no-risk-screening':(screeningResultHistory.excessFactor < 1.0)}">

                                                                    </span>
                                                                    <span [ngSwitch]="screeningResultHistory.excessFactor >= 1.0"
                                                                        style="vertical-align:text-bottom">
                                                                        <span *ngSwitchCase="true">
                                                                            <b>Risiko</b>
                                                                        </span>
                                                                        <span *ngSwitchCase="false">Ingen
                                                                            risiko</span>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span [ngSwitch]="screeningResultHistory.excessFactor >= 1.0">
                                                                        <span *ngSwitchCase="true">
                                                                            <b>{{getValidNumber(screeningResultHistory.excessFactor)
                                                                                | number:'1.0-1'}}</b>
                                                                        </span>
                                                                        <span *ngSwitchCase="false">
                                                                            {{getValidNumber(screeningResultHistory.excessFactor)
                                                                            | number:'1.0-1'}}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td>{{getNumberWithSignificantDigits(screeningResultHistory.concentration)}}
                                                                    µg/L
                                                                </td>
                                                                <td>{{getValidNumber(screeningResultHistory.qualityCriterion)
                                                                    | number:'1.0-2'}}
                                                                    µg/L</td>
                                                                <td>
                                                                    <span
                                                                        *ngIf="screeningResultHistory.flag > 0 && hasFlag(screeningResultHistory.flag)">
                                                                        <i class="fa fa-flag text-danger"></i>
                                                                    </span>
                                                                    <span
                                                                        *ngIf="screeningResultHistory.flag ===0 || !hasFlag(screeningResultHistory.flag)">
                                                                        -
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="btn btn-primary float-right mt-3" data-dismiss="modal"><i
                        class="fa fa-arrow-circle-left fa-lg"></i> Tilbage</button>
            </div>
        </div>
    </div>
</div>

<!-- Missing compounds -->
<div *ngIf="location" class="modal fade" id="missingModelCompound" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content p-4">

            <div class="modal-body">
                <h2>Liste over manglende modelstoffer</h2>
                <p class="text-muted">{{location?.number}} - {{location?.name}}</p>

                <div *ngIf="pageStates.isLoadingMissingModelCompound" class="mt-5 text-center">
                    <app-load-indicator style="width: 20px; height: 20px;"></app-load-indicator>
                    <h6 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter... </h6>
                    <p class="text-muted mt-1">Det tager et øjeblik</p>
                </div>

                <div *ngIf="pageStates.isLoadingMissingModelCompound == false">
                    <div
                        *ngIf="screeningDetails.missingActivities && screeningDetails.missingActivities.length > 0; else noMissingActivities">
                        <div class="mb-4">
                            <h6>
                                <i class="fa fa-circle"></i> Aktiviteter
                            </h6>
                            <div class="collapse collapse-content" class="show">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 20%;">Aktivitetskode</th>
                                            <th style="width: 30%;">Aktivitet</th>
                                            <th style="width: 40%;">Oversat Stof</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let missingActivity of screeningDetails.missingActivities">
                                            <td>{{missingActivity.code}}</td>
                                            <td>{{missingActivity.description}}</td>
                                            <td>{{missingActivity.translatedCompound
                                                ? missingActivity.translatedCompound
                                                : 'Aktivitet kunne ikke oversættes til stof' }}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <ng-template #noMissingActivities>
                        <h6>
                            <i class="fa fa-circle"></i> Aktiviteter <small class="text-muted mt-1">(Ingen data)</small>
                        </h6>
                    </ng-template>

                    <div
                        *ngIf="screeningDetails.missingPollutionCauses && screeningDetails.missingPollutionCauses.length > 0; else noMissingPollutionCauses">
                        <div class="mb-4">
                            <h6>
                                <i class="fa fa-circle"></i> Brancher
                            </h6>
                            <div class="collapse collapse-content" class="show">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 20%;">Branchekode</th>
                                            <th style="width: 30%;">Branche</th>
                                            <th style="width: 40%;">Oversat Stof</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let missingPollutionCause of screeningDetails.missingPollutionCauses">
                                            <td>{{missingPollutionCause.code}}</td>
                                            <td>{{missingPollutionCause.description}}</td>
                                            <td>{{missingPollutionCause.translatedCompound
                                                ? missingPollutionCause.translatedCompound
                                                : 'Branche kunne ikke oversættes til stof' }}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <ng-template #noMissingPollutionCauses>
                        <h6>
                            <i class="fa fa-circle"></i> Brancher <small class="text-muted mt-1">(Ingen data)</small>
                        </h6>
                    </ng-template>

                    <div
                        *ngIf="screeningDetails.missingPollutantComponents && screeningDetails.missingPollutantComponents.length > 0; else noMissingPollutantComponents">
                        <div class="mb-4">
                            <h6>
                                <i class="fa fa-circle"></i> Stoffer
                            </h6>
                            <div class="collapse collapse-content" class="show">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 20%;">Stofkode</th>
                                            <th style="width: 30%;">Stofnavn </th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let missingmissingPollutant of screeningDetails.missingPollutantComponents">
                                            <td>{{missingmissingPollutant.code}}</td>
                                            <td>{{missingmissingPollutant.description}}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <ng-template #noMissingPollutantComponents>
                        <h6>
                            <i class="fa fa-circle"></i> Stoffer <small class="text-muted mt-1">(Ingen data)</small>
                        </h6>
                    </ng-template>
                </div>

                <button class="btn btn-primary float-right mt-3" data-dismiss="modal">
                    <i class="fa fa-arrow-circle-left fa-lg"></i> Tilbage
                </button>
            </div>
        </div>
    </div>
</div>